/* eslint-disable */

'use strict'
const _ = require('lodash')
let lastReceivedMsg = null
const DEFAULT_ICON_URL = 'static.parastorage.com/services/santa-resources/resources/editor/designPanel/panelTypes/default_pin_icon'
const DEFAULT_ICON_WIDTH = 21
const DEFAULT_ICON_HEIGHT = 34

function getUrlParams(search) {
    const [query, locationsArray] = search.substring(1).split('&locations=')
    const queryPairs = query.split('&')
    let queryPair
    let i
    const params = {}

    for (i = 0; i < queryPairs.length; i++) {
        queryPair = queryPairs[i].split('=')
        params[decodeURIComponent(queryPair[0])] = decodeURIComponent(queryPair[1] || '')
    }

    if (locationsArray && locationsArray.length > 0) {
        params.locations = JSON.parse(decodeURIComponent(locationsArray.concat(location.hash))) //todo links for each marker can't rely on hash
    }

    return params
}

function castMapParams(params) {
    function isTruthy(val) {
        return val === true || val === 'true'
    }
    if (!params.locations) {
        params.lat = parseFloat(params.lat) || 37.7552464
        params.long = parseFloat(params.long) || -122.4185384
        params.addressInfo = (params.addressInfo || '').trim().replace(/<\/?[^>]+>/g, ' ')
        params.address = (params.address || '').trim().replace(/<\/?[^>]+>/g, ' ')
    } else {
        params.showDirectionLink = isTruthy(params.showDirectionsLink)
    }
    params.showZoom = isTruthy(params.showZoom)
    params.showStreetView = isTruthy(params.showStreetView)
    params.showMapType = isTruthy(params.showMapType)
    params.mapInteractive = isTruthy(params.mapInteractive)
    return params
}

function getMapParams(params) {
    const convertedParams = {
        zoom: params.locations ? params.zoom : 14,
        gestureHandle: 'cooperative',
        center: window.googleMapsLatLongInstance,
        zoomControl: params.showZoom,
        streetViewControl: params.showStreetView,
        mapTypeControl: params.showMapType,
        scaleControl: true,
        draggable: params.mapInteractive,
        disableDefaultUI: !params.mapInteractive,
        disableDoubleClickZoom: !params.mapInteractive
    }

    if (params.mapType) {
        convertedParams.mapTypeId = google.maps.MapTypeId[params.mapType]
    }

    if (params.mapStyle) {
        convertedParams.styles = JSON.parse(params.mapStyle)
    }

    if (params.locations && typeof params.locations === 'string') {
        convertedParams.locations = JSON.parse(params.locations)
    }

    return convertedParams
}

function getMarkerTitle(params) {
    return params.addressInfo ? '' : 'Click to see more...'
}

function getInfoWindowContent(params) {
    return params.addressInfo || params.address
}

function getDirectionLink(location, showDirectionLink) {
    if (showDirectionLink) {
        const destination = encodeURI(location.address)
        const directionsLink = `https://www.google.com/maps/dir/?api=1&destination=${destination}`
        return `<a href="${directionsLink}" target="_blank">Directions</a>`
    }
    return ''
}

function shouldRenderLinkOnPreview(isPreview, target, linkType) {
    const linkTypesToAlwaysRender = ['AnchorLink', 'EmailLink']
    return !isPreview || target !== '_self' || _.includes(linkTypesToAlwaysRender, linkType)
}

function getLocationLink(location, isPreview) {
    if (!_.isEmpty(location.locationLinkAttributes)) {
        let aTag = ''

        if (!shouldRenderLinkOnPreview(isPreview, location.locationLinkAttributes.target, location.link.type)) {
            delete location.locationLinkAttributes.href;
        }
        _.forEach(location.locationLinkAttributes, function (value, key) {
            if (key === 'target' && value === '_self') {
                aTag = aTag.concat('target="_top" ')
            } else {
                aTag = aTag.concat(`${key}="${value}" `)
            }
        })
        return `<a ${aTag}>${location.linkTitle}</a>`
    }
    return ''
}

function getLocationLinkAttribute(location, attribute) {
    if (location[attribute]) {
        return `${location[attribute]}`
    }
    return ''
}


function createInfoWindowContent(location, showDirectionLink, isPreview) {
    const content = `<div id="content">
                <p><b>${getLocationLinkAttribute(location, 'title')}</b></p>
                <p>${getLocationLinkAttribute(location, 'description')}</p>
                <p>${getLocationLink(location, isPreview)}</p>
                <p>${getDirectionLink(location, showDirectionLink)}</p></div>`
    return content
}

function createMap(params) {
    const formattedParams = getMapParams(params)
    const map = new google.maps.Map(window.document.getElementById('map_canvas'), formattedParams)
    return map
}

function isDefaultIcon(iconUrl) {
    return _.includes(iconUrl, DEFAULT_ICON_URL)
}

function getImageIcon(icon) {
    const imageIcon = {url: icon, anchor: new google.maps.Point(11.5, 34)}
    return _.assign(imageIcon, isDefaultIcon(imageIcon.url) ? {scaledSize: new google.maps.Size(DEFAULT_ICON_WIDTH, DEFAULT_ICON_HEIGHT)} : {})
}

function createMarker(map, title, position, icon) {
    const options = {
        position,
        map,
        title
    }

    return new google.maps.Marker(_.assign(options, icon ? {
        icon: _.isString(icon) ? getImageIcon(icon) : _.assign(icon, {anchor: new google.maps.Point(32, 64)})} : {}))
}

function createMarkerByPlaceId(map, title, placeId, icon) {
    return new Promise(resolve => {
        const service = new google.maps.places.PlacesService(map);
        service.getDetails({placeId}, function (result) {
            const options = {
                map: map,
                place: {
                    placeId,
                    location: result.geometry.location
                },
                title
            }
            resolve(new google.maps.Marker(_.assign(options, icon ? {
                icon: _.isString(icon) ? getImageIcon(icon) : _.assign(icon, {anchor: new google.maps.Point(32, 64)})} : {})))
        })
    })
}


function getLatLngFromPlaceId(placeId) {
    return new Promise(resolve => {
        const service = new google.maps.places.PlacesService(window.googleMapsInstance);
        service.getDetails({placeId}, function (result) {
            resolve({latitude: result.geometry.location.lat(), longitude: result.geometry.location.lng()})
        })
    })
}

function createMarkers(map, locations, markers, infoWindows, showDirectionLink) {
    locations.forEach(function (location) {
        addLocation(map, markers, infoWindows, location, showDirectionLink, null, _.noop) //todo deal with passing icon once this prop is added
    })
}

function shouldUseMarkerWithPlaceId(location) {
    return !_.isEmpty(location.address) && !_.isNumber(location.longitude) || !_.isNumber(location.latitude)
}

async function addMarker(map, location) {
    if (shouldUseMarkerWithPlaceId(location)) {
        return await createMarkerByPlaceId(map, location.title, location.address, location.icon)
    }
    return createMarker(map, location.title, {lat: location.latitude, lng: location.longitude}, location.icon)
}

async function addLocation(map, markers, infoWindows, location, showDirectionLink, isPreview, callback) {
    const marker = await addMarker(map, location)
    markers.push(marker)
    marker.addListener('click', function() {
        const markerData = getDataFromMarker(marker)
        window.parent.postMessage(JSON.stringify({type: 'MARKER_CLICKED', data: markerData}), '*')
    })
    const infoWindow = createInfoWindow(createInfoWindowContent(location, showDirectionLink, isPreview))
    infoWindows.push(infoWindow)
    bindEvents(map, marker, infoWindow)
    if (_.isFunction(callback)) {
        callback(marker, infoWindow)
    }
}

function createLatLong(lat, long) {
    return new google.maps.LatLng(lat, long)
}

function createInfoWindow(content) {
    return new google.maps.InfoWindow({
        maxWidth: (window.innerWidth ? window.innerWidth : window.document.documentElement.clientWidth) * 0.7, // fix for autoPan bug
        content
    })
}

function isInfoWindowCentered(infoWindow) {
    return infoWindow.position.lat() === window.googleMapsLatLongInstance.lat() && infoWindow.position.lng() === window.googleMapsLatLongInstance.lng()
}

function shouldDisplayInfo(location, showDirectionsLink) {
    const locationHasInfo  = !_.isEmpty(location['title']) || !_.isEmpty(location['description']) || !_.isEmpty(location['linkTitle']) && !_.isEmpty(location['link'])
    return showDirectionsLink || locationHasInfo
}

function updateLocations(map, locations, showDirectionLink, isPreview, shouldKeepMarkers) {
    if (shouldKeepMarkers && window.googleMapsMarkerInstances.length > 0) {
        locations.forEach(function (location, key) {
            setOptions(window.googleMapsMarkerInstances[key], window.googleMapsInfoWindowInstances[key], {position: createLatLong(location.latitude, location.longitude), title: location.title}, {position: createLatLong(location.latitude, location.longitude), content: createInfoWindowContent(location, showDirectionLink, isPreview)})
        })
        window.googleMapsInfoWindowInstances.forEach((infoWindow, i) => {
            infoWindow.close()
            if (isInfoWindowCentered(infoWindow) && shouldDisplayInfo(locations[i], showDirectionLink)) {
                infoWindow.open(map, window.googleMapsMarkerInstances[i])
                map.setCenter(window.googleMapsLatLongInstance)
            }
        })
    } else {
        window.googleMapsMarkerInstances.forEach(function(marker) {
            marker.setMap(null)
        })
        window.googleMapsInfoWindowInstances.forEach(function(infoWindow) {
            infoWindow.close()
            infoWindow.setMap(null)
        })
        window.googleMapsMarkerInstances = []
        window.googleMapsInfoWindowInstances = []
        locations.forEach(function (location, index) {
            function addLocationCallback(marker, infoWindow) {
                setOptions(marker, infoWindow, {position: createLatLong(location.latitude, location.longitude), title: location.title}, {position: createLatLong(location.latitude, location.longitude), content: createInfoWindowContent(location, showDirectionLink, isPreview)})
                marker.additionalContent = {
                    description: location.description,
                    link: _.get(location.link, 'url'),
                    linkTitle: location.linkTitle,
                    title: location.title,
                    icon: location.pinIcon,
                    address: location.address
                }
                if (infoWindow.position && isInfoWindowCentered(infoWindow) && shouldDisplayInfo(location, showDirectionLink) && window.centeredLocationIndex === index) {
                    infoWindow.open(map, marker)
                }
            }
            addLocation(map, window.googleMapsMarkerInstances, window.googleMapsInfoWindowInstances, location, showDirectionLink, null, addLocationCallback)
        })
    }
}

function setOptions(markerInstance, infoWindowInstance, markerOptions, infoWindowOptions) {
    if (markerInstance && infoWindowInstance) {
        markerInstance.setOptions(markerOptions)
        infoWindowInstance.setOptions(infoWindowOptions)
    }
}

async function updateMap(msg) {
    if (!msg || !window.googleMapsInstance) {
        return
    }

    const parsedParams = JSON.parse(msg.data)
    if (parsedParams.locations) {
        const centeredLocation = parsedParams.locations[parsedParams.defaultLocation]
        window.centeredLocationIndex = parsedParams.defaultLocation
        if (shouldUseMarkerWithPlaceId(centeredLocation)) {
            const {longitude, latitude} = await getLatLngFromPlaceId(centeredLocation.address)
            window.googleMapsLatLongInstance = createLatLong(latitude, longitude)
        } else {
            window.googleMapsLatLongInstance =  createLatLong(centeredLocation.latitude, centeredLocation.longitude)
        }
        updateLocations(window.googleMapsInstance, parsedParams.locations, parsedParams.showDirectionsLink, parsedParams.isPreview, parsedParams.shouldKeepMarkers)
        const formattedParams = getMapParams(parsedParams)
        window.googleMapsInstance.setOptions(formattedParams)
    } else {
        window.googleMapsLatLongInstance = createLatLong(parsedParams.lat, parsedParams.long)
        const formattedParams = getMapParams(parsedParams)
        window.googleMapsInstance.setOptions(formattedParams)
        setOptions(window.googleMapsMarkerInstance, window.googleMapsInfoWindowInstance, {position: window.googleMapsLatLongInstance, title: getMarkerTitle(parsedParams)}, {position: window.googleMapsLatLongInstance, content: getInfoWindowContent(parsedParams)})
    }
}

function newBindEvents(map) {
    map.addListener('zoom_changed', function () {
        window.parent.postMessage(JSON.stringify({
            type: 'ZOOM_UPDATED',
            data: map.getZoom()
        }), '*')
    });

    map.addListener('center_changed', function () {
        const mapCenter = window.googleMapsInstance.getCenter()
        window.parent.postMessage(JSON.stringify({
            type: 'CENTER_UPDATED',
            data: {
                longitude: mapCenter.lng(),
                latitude: mapCenter.lat()
            }
        }), '*')
    });
}

function bindEvents(map, marker, infoWindow) {
    google.maps.event.addListener(marker, 'click', function () {
        marker.setTitle('')
        _.invokeMap(window.googleMapsInfoWindowInstances, 'close')
        infoWindow.open(map, marker)
    })

    google.maps.event.addListener(infoWindow, 'closeclick', function () {
        marker.setTitle('Click to see more...')
        map.setCenter(window.googleMapsLatLongInstance)
    })
}

function loadScript(language, clientKey) {
    const clientKeyUrlParam = clientKey ? `&key=${clientKey}` : `&client=gme-wixcomltd2`

    const scriptNode = window.document.createElement('script')
    scriptNode.type = 'text/javascript'
    scriptNode.src = `//maps.googleapis.com/maps/api/js?callback=initMap${clientKeyUrlParam}&libraries=places&language=${language}`

    window.document.body.appendChild(scriptNode)
}

function initMap() {
    let parsedMsg
    try {
        parsedMsg = JSON.parse(lastReceivedMsg.data)
    } catch (e) {
        parsedMsg = getUrlParams(location.search)
    }

    const parsedParams = castMapParams(parsedMsg)
    if (parsedMsg.locations) {
        window.centeredLocationIndex = parsedMsg.defaultLocation
        window.googleMapsLatLongInstance = createLatLong(parsedMsg.locations[parsedMsg.defaultLocation].latitude, parsedMsg.locations[parsedMsg.defaultLocation].longitude)
        window.googleMapsInstance = createMap(parsedParams)
        window.googleMapsInstance.addListener('click', function(event) {
            window.parent.postMessage(JSON.stringify({
                type: 'MAP_CLICKED',
                data: {
                    longitude: event.latLng.lng(),
                    latitude: event.latLng.lat()
                }
            }), '*')
        })
        window.googleMapsMarkerInstances = []
        window.googleMapsInfoWindowInstances = []
        createMarkers(window.googleMapsInstance, parsedMsg.locations, window.googleMapsMarkerInstances, window.googleMapsInfoWindowInstances, parsedParams.showDirectionLink)
        newBindEvents(window.googleMapsInstance)
    } else {
        window.googleMapsLatLongInstance = createLatLong(parsedParams.lat, parsedParams.long)
        window.googleMapsInstance = createMap(parsedParams)
        window.googleMapsMarkerInstance = createMarker(window.googleMapsInstance, getMarkerTitle(parsedParams), window.googleMapsLatLongInstance)
        window.googleMapsInfoWindowInstance = createInfoWindow(getInfoWindowContent(parsedParams))
        window.googleMapsInfoWindowInstance.open(window.googleMapsInstance, window.googleMapsMarkerInstance)
        bindEvents(window.googleMapsInstance, window.googleMapsMarkerInstance, window.googleMapsInfoWindowInstance)
    }
}

window.initMap = initMap
window.updateMap = updateMap

function saveMsgAndUpdateMap(msg) {
    lastReceivedMsg = msg
    updateMap(msg)
}

function sendMapInstanceAndMarkers() {
    const visibleMarkers = getVisibleMarkers(window.googleMapsInstance, window.googleMapsMarkerInstances)
    window.parent.postMessage(JSON.stringify({
        type: 'MARKERS',
        data: visibleMarkers.map(getDataFromMarker)
    }), '*')
}

function setMapCenter(message) {
    try {
        const center = JSON.parse(message.data)
        window.googleMapsInstance.setCenter(new google.maps.LatLng(center.latitude, center.longitude))
        window.parent.postMessage(JSON.stringify({
            type: 'SET_CENTER_FINISHED',
        }), '*')
    } catch (e) {
        return
    }
}

function setMapZoom(message) {
    window.googleMapsInstance.setZoom(message.data)
    window.parent.postMessage(JSON.stringify({
        type: 'SET_ZOOM_FINISHED',
    }), '*')
}

function getDataFromMarker(marker) {
    const position = _.get(marker, 'place.location') ? marker.place.location : marker.getPosition()
    const additionalContent = marker.additionalContent || {}
    return {
        location: {
            longitude: position.lat(),
            latitude: position.lng()
        },
        icon: additionalContent.icon,
        title: additionalContent.title,
        link: additionalContent.link,
        address: additionalContent.address,
        linkTitle: additionalContent.linkTitle,
        description: additionalContent.description
    }
}

function getVisibleMarkers(mapInstance, markers) {
    const mapBounds = mapInstance.getBounds()
    return markers.filter(marker => mapBounds.contains(_.get(marker, 'place.location') ? marker.place.location : marker.getPosition()))
}

function handlePostMessage(message) {
    const messageType = _.get(message, 'data.type')
    if (messageType === 'GET_MARKERS') {
        sendMapInstanceAndMarkers()
    } else if (messageType === 'SET_CENTER') {
        setMapCenter(message.data)
    } else if (messageType === 'SET_ZOOM') {
        setMapZoom(message.data)
    } else {
        saveMsgAndUpdateMap(message)
    }
}

function initialize() {
    window.addEventListener('message', handlePostMessage, false)
    const clientKey = (window.location.href.match(/[?&]clientKey=([^&]+)/) || [])[1]
    loadScript(getUrlParams(location.search).language, clientKey)
}

module.exports = {
    loadScript,
    initialize,
    getDirectionLink,
    getLocationLink,
    createMarkers,
    createMarker,
    addMarker,
    getLocationLinkAttribute,
    createInfoWindowContent,
    updateMap,
    initMap,
    getUrlParams,
    addLocation,
    setOptions,
    createLatLong,
    getMapParams,
    shouldDisplayInfo,
    shouldRenderLinkOnPreview
}
